<template>
  <div class="cardOrganiser" style="margin-bottom: 100px;">
    <div class="cardColumn" style="max-width: 15%; margin-right: 15px;">
      <div class="housegraphverticaltext">
        <h1 :class="graphTitleSmall === true ? 'highlight' : 'aoi'">{{ graphTitle }}</h1>
      </div>
      <div class="housegraphrow" style="min-height: 170px;"/>
      <div class="housegraphrow">
        <div class="housegraphcolumn xborder" style="max-width: 100%; align-items: end;">
          <svg-icon icon-class="blue-warranty" style="font-size: 50px; margin-bottom: 5px;"/>
          <h3>Suppliers</h3>
        </div>
        <svg-icon icon-class="arrow-thin-right" style="font-size: 30px; z-index: 5;"/>
      </div>
    </div>
    <div class="cardColumn" style="max-width: 65%;">
      <div class="housegraphrow" style="min-height: 170px;">
        <div class="housegraphbackgroundlayer">
          <!-- <div class="housegraphtriangle"/> -->
           <img :src="roof" style="width: 100%; height: 100%"/>
        </div>
        <div class="housegraphcolumn xborder" style="max-width: 40%; padding-bottom: 50px;">
          <h3>Leadership</h3>
          <!-- <div v-if="graphTitleSmall === true">
            <div v-for="(lowlight, key) in registerForm.findingDescription[0]">
              <p :key=key style="font-size: 12px;">{{ lowlight.no }}. {{ lowlight.findingDescription }}</p>
            </div>
          </div>
          <div v-else>
            <div v-for="(highlight, key) in registerForm.findingDescription[0]">
              <p :key=key style="font-size: 12px;">{{ highlight.no }}. {{ highlight.findingDescription }}</p>
            </div>
          </div> -->
          <div v-for="(object, objectkey) in leadershipGraphData" :key="objectkey">
            <p>{{ objectkey + 1 }}. {{ object.findingDescription }}</p>
          </div>
          <div style="flex-direction: row; display: flex; position: absolute; top: 70%; transform: rotate(-25deg);">
            <svg-icon icon-class="arrow-thin-right" style="font-size: 30px; z-index: 5; transform: rotate(90deg);"/>
          </div>
        </div>
        <div class="housegraphcolumn xborder" style="max-width: 70%; padding-top: 50px; align-items: center; text-align: center;">
          <h3>Smart Factory Strategy</h3>
          <!-- <div v-if="graphTitleSmall === true">
            <div v-for="(lowlight, key) in registerForm.findingDescription[1]">
              <p :key=key>{{ lowlight.no }}. {{ lowlight.findingDescription }}</p>
            </div>
          </div>
          <div v-else>
            <div v-for="(highlight, key) in registerForm.findingDescription[1]">
              <p :key=key>{{ highlight.no }}. {{ highlight.findingDescription }}</p>
            </div>
          </div> -->
          <div v-for="(object, objectkey) in strategyGraphData" :key="objectkey">
            <p>{{ objectkey + 1 }}. {{ object.findingDescription }}</p>
          </div>
        </div>
        <div class="housegraphcolumn xborder" style="max-width: 40%; padding-bottom: 50px; align-items: end; text-align: right;">
          <h3>Competency</h3>
          <!-- <div v-if="graphTitleSmall === true">
            <div v-for="(lowlight, key) in registerForm.findingDescription[2]">
              <p :key=key style="font-size: 12px;">{{ lowlight.no }}. {{ lowlight.findingDescription }}</p>
            </div>
          </div>
          <div v-else>
            <div v-for="(highlight, key) in registerForm.findingDescription[2]">
              <p :key=key style="font-size: 12px;">{{ highlight.no }}. {{ highlight.findingDescription }}</p>
            </div>
          </div> -->
          <div v-for="(object, objectkey) in competencyGraphData" :key="objectkey">
            <p>{{ objectkey + 1 }}. {{ object.findingDescription }}</p>
          </div>
          <div style="flex-direction: row; display: flex; position: absolute; top: 70%; transform: rotate(25deg);">
            <svg-icon icon-class="arrow-thin-left" style="font-size: 30px; z-index: 5; transform: rotate(-90deg);"/>
          </div>
        </div>
      </div>
      <div class="housegraphrow">
        <div class="housegraphcolumn" style="max-width: 100%;">
          <h3>Horizontal Integration</h3>
           <div v-for="(object, objectkey) in horizontalIntegrationGraphData" :key="objectkey">
            <p>{{ objectkey + 1 }}. {{ object.findingDescription }}</p>
          </div>
        </div>
      </div>
      <div class="housegraphrow">
        <div class="housegraphcolumn" style="max-width: 100%;">
          <h3>Facility</h3>
           <div v-for="(object, objectkey) in facilityGraphData" :key="objectkey">
            <p>{{ objectkey + 1 }}. {{ object.findingDescription }}</p>
          </div>
        </div>
      </div>
      <div class="housegraphrow">
        <div class="housegraphcolumn" style="max-width: 50%;">
          <h3>Enterprise</h3>
           <div v-for="(object, objectkey) in enterpriseGraphData" :key="objectkey">
            <p>{{ objectkey + 1 }}. {{ object.findingDescription }}</p>
          </div>
        </div>
        <div class="housegraphcolumn" style="max-width: 50%;">
          <h3>Shop Floor </h3>
           <div v-for="(object, objectkey) in shopFloorGraphData" :key="objectkey">
            <p>{{ objectkey + 1 }}. {{ object.findingDescription }}</p>
          </div>
        </div>
        <div style="flex-direction: row; display: flex; position: absolute; right: calc(50% - 10px); top: 30%;">
          <svg-icon icon-class="arrow-thin-right" style="font-size: 30px; z-index: 5;"/>
        </div>
        <div style="flex-direction: row; display: flex; position: absolute; left: 30%; top: calc(90% - 5px)">
          <svg-icon icon-class="arrow-thin-up" style="font-size: 30px; z-index: 5;"/>
          <!-- <svg-icon icon-class="arrow-thin-up" style="font-size: 25px;"/> -->
        </div>
        <div style="flex-direction: row; display: flex; position: absolute; right: 30%; top: calc(90% - 5px)">
          <svg-icon icon-class="arrow-thin-down" style="font-size: 30px; z-index: 5;"/>
          <!-- <svg-icon icon-class="arrow-thin-down" style="font-size: 25px;"/> -->
        </div>
      </div>
      <div class="cardOrganiser">
        <div class="housegraphcolumn" style="max-width: 100%;">
          <div class="housegraphrow">
            <div class="housegraphcolumn xborder" style="max-width: 50%;">
            <h3>Cybersecurity</h3>
             <div v-for="(object, objectkey) in cybersecurityGraphData" :key="objectkey">
              <p>{{ objectkey + 1 }}. {{ object.findingDescription }}</p>
            </div>
          </div>
          <div class="housegraphcolumn xborder" style="max-width: 50%;">
            <h3>Performance Management</h3>
             <div v-for="(object, objectkey) in performanceGraphData" :key="objectkey">
              <p>{{ objectkey + 1 }}. {{ object.findingDescription }}</p>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div class="housegraphrow">
        <div class="housegraphcolumn" style="max-width: 100%;">
          <h3>Production Management</h3>
           <div v-for="(object, objectkey) in productionGraphData" :key="objectkey">
            <p>{{ objectkey + 1 }}. {{ object.findingDescription }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="cardColumn" style="max-width: 15%; margin-left: 5px;">
      <div class="housegraphrow" style="min-height: 170px;"/>
      <div class="housegraphrow">
        <svg-icon icon-class="arrow-thin-left" style="font-size: 30px; z-index: 5;"/>
        <div class="housegraphcolumn xborder" style="max-width: 100%;">
          <svg-icon icon-class="blue-warranty" style="font-size: 50px; margin-bottom: 5px;"/>
          <h3>Customers</h3>
        </div>
      </div>
      <div class="housegraphrow" style="min-height: 45px;">
        <svg-icon icon-class="arrow-thin-up" style="font-size: 30px; z-index: 5;"/>
      </div>
      <div class="housegraphrow">
        <svg-icon icon-class="arrow-thin-right" style="font-size: 30px; margin-right: 5px;"/>
        <div class="housegraphcolumn" style="max-width: 100%;">
          <h3>Product <span style="font-size: 13px; font-weight: 600;">Individualisation</span></h3>
          <div v-for="(object, objectkey) in productGraphData" :key="objectkey">
            <p>{{ objectkey + 1 }}. {{ object.findingDescription }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  selfAssessmentSubmissions,
  assessorsaveAssessmentSubmissions,
  assessorsubmitAssessmentSubmissions,
  assessordevSubmitAssessmentSubmissions,
  getAssessmentSubmissionById,
} from "@/api/msmaAssessmentSubmissions";
import roof from "@/assets/housegraphroof-test.png"

export default {
  name: "house-graph",
  data() {
    return {
      roof,
      registerForm: {
        findingDescription: [
          [
            {
              "no": "1",
              "checked": true,
              "findingDescription": "Leadership Highlight 1",
            },
            {
              "no": "2",
              "checked": true,
              "findingDescription": "Leadership Highlight 2",
            }
          ],
          [
            {
              "no": "1",
              "checked": true,
              "findingDescription": "The management has established a Smart Factory Transformation team.",
            },
            {
              "no": "2",
              "checked": true,
              "findingDescription": "The strategy is well documented and has been implemented.",
            }
          ],
          [
            {
              "no": "1",
              "checked": true,
              "findingDescription": "Competency Highlight 1",
            },
            {
              "no": "2",
              "checked": true,
              "findingDescription": "Competency Highlight 2",
            }
          ],
        ],
        findingDescription: [
          [
            {
              "no": "1",
              "checked": true,
              "findingDescription": "Leadership Lowlight 1",
            },
            {
              "no": "2",
              "checked": true,
              "findingDescription": "Leadership Lowlight 2",
            }
          ],
          [
            {
              "no": "1",
              "checked": true,
              "findingDescription": "The company does not have any strategy related to smart factory.",
            }
          ],
          [
            {
              "no": "1",
              "checked": true,
              "findingDescription": "Competency Lowlight 1",
            },
            {
              "no": "2",
              "checked": true,
              "findingDescription": "Competency Lowlight 2",
            }
          ],
        ],
      },
      processHighlightsTable:"",
      processLowlightsTable:"",
      technologyHighlightsTable:"",
      technologyLowlightsTable:"",
      findingDescription:"",
      findingDescription:"",
      findingDescription:"",
      findingDescription:"",
    }
  },
  props: {
    graphData: {
      type: Array
    },
    leadershipGraphData: {
      type: Array
    },
    strategyGraphData: {
      type: Array
    },
    competencyGraphData: {
      type: Array
    },
    horizontalIntegrationGraphData: {
      type: Array
    },
    facilityGraphData: {
      type: Array
    },
    enterpriseGraphData: {
      type: Array
    },
    shopFloorGraphData: {
      type: Array
    },
    cybersecurityGraphData: {
      type: Array
    },
    performanceGraphData: {
      type: Array
    },
    productionGraphData: {
      type: Array
    },
    productGraphData: {
      type: Array
    },
    graphTitle: {
      type: String
    },
    placeholderText: {
      type: String
    },
    graphTitleSmall: {
      type: Boolean
    }
  },
  async fetchData(){
    this.registerForm = {
      findingDescription: assessmentSubmission.findingDescription ? assessmentSubmission.findingDescription : '',
      findingDescription: assessmentSubmission.findingDescription ? assessmentSubmission.findingDescription : '',
      findingDescription: assessmentSubmission.findingDescription ? assessmentSubmission.findingDescription : '',
      findingDescription: assessmentSubmission.findingDescription ? assessmentSubmission.findingDescription : '',
      findingDescription: assessmentSubmission.findingDescription ? assessmentSubmission.findingDescription : '',
      findingDescription: assessmentSubmission.findingDescription ? assessmentSubmission.findingDescription : '',
    }
  },

  
  methods: {
  },
  watch: {
  },
  computed: {
  },
  mounted() {
  },
  beforeDestroy() {
  }
};
</script>
<style lang="scss">

h3 {
  font-weight: 600 !important;
  // text-shadow: 0px 0px 1px var(--v4-dark-font-color);
}

.housegraphcolumn {
  display: flex;
  position: relative;
  width: 100%;
  // height: 100%;
  max-width: 100%;
  min-width: 0px;
  // max-height: 100%;
  // min-height: 0%;
  margin: 0px;
  padding: 10px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-width: 5px;
  border-style: double;
  border-radius: 5px;
  border-color: var(--darker-border-color);
  p {
    font-size: 0.8em;
  }
}
.housegraphcolumn.xborder {
  border-color: transparent;
}
.housegraphrow {
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 100%;
  min-width: 0px;
  max-height: 100%;
  min-height: 0%;
  margin: 0px;
  flex-direction: row;
  justify-content: center;
  // align-items: center;
}
.housegraphbackgroundlayer {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
}
.housegraphtriangle {
  --b: 5px;
  height: 175px;
  aspect-ratio: 4;
  -webkit-clip-path: polygon(50% 0, 100% 100%, 0 100%, 50% 0, 50% var(--b), calc(var(--b) /(2 - sqrt(2))) calc(100% - var(--b) / sqrt(2)), calc(100% - var(--b) /(2 - sqrt(2))) calc(100% - var(--b) / sqrt(2)), 50% var(--b));
  clip-path: polygon(50% 0, 100% 100%, 0 100%, 50% 0, 50% var(--b), calc(var(--b) /(2 - sqrt(2))) calc(100% - var(--b) / sqrt(2)), calc(100% - var(--b) /(2 - sqrt(2))) calc(100% - var(--b) / sqrt(2)), 50% var(--b));
  background-color: var(--darker-border-color);
}
.housegraphverticaltext{
  position: absolute;
  left: 0%;
  top: 0%;
  text-orientation: upright; 
  writing-mode: vertical-lr;
  h1 {
    font-size: 40px;
    font-family: serif;
    background: -webkit-linear-gradient(#eee, var(--darker-border-color));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  h1.highlight {
    // font-size: 50px;
    // font-weight: 800; 
  }
  h1.aoi {
    // font-size: 30px; z-index: 5;
    // font-weight: 100; 
  }
}

</style>


// WEBPACK FOOTER //
// src/views/msma/components/HouseGraph.vue